var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { QuillEditorComponent } from './quill-editor.component';
var QuillModule = (function () {
    function QuillModule() {
    }
    return QuillModule;
}());
QuillModule = __decorate([
    NgModule({
        declarations: [
            QuillEditorComponent
        ],
        imports: [],
        exports: [QuillEditorComponent],
        providers: []
    })
], QuillModule);
export { QuillModule };
//# sourceMappingURL=quill.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-quill/src/quill.module.js
// module id = 560
// module chunks = 0